<template>
    <div class="py-2 border-b border-gray-100 flex flex-col">
        <div class="flex flex-wrap">
            <span class="font-bold">
                {{ project.user }}
            </span>
        </div>
        <div class="my-2 transition w-full" >
            <div class="font-bold flex mb-2 text-xs">
                <div class="w-1/4">Poznámka</div>
                <div class="w-1/4">Od - Do</div>
                <div class="w-1/4">Oprava</div>
                <div class="w-1/4 text-right">Trvanie</div>
            </div>
            <div v-for="activity in project.activities" class="flex flex-wrap w-full mb-2 items-center">
                <span class="w-1/4 flex items-center">
                    <md-button
                        @click="() => markAsInvoiced(activity)"
                        class="md-dense md-icon-button"
                        :class="activity.invoiced ? `md-accent` : ``"
                        :title="activity.invoiced ? `Fakturované` : `Fakturovať`">
                        <md-icon>check</md-icon>
                    </md-button>
                    {{ activity.note }}
                </span>
                <span class="w-1/4">
                    {{ formatActivityDate(activity.from) }} - {{ formatActivityDate(activity.to) }}
                </span>
                <span class="w-1/4">
                    {{ activity.fixing ? `Áno` : `Nie` }}
                </span>
                <span class="ml-auto">{{ formatTotal(activity.length) }}</span>
            </div>
        </div>
        <span class="ml-auto">
            Celkový cas za deň: <span class="font-bold">{{ formatTotal(project.total_time) }}</span>
        </span>
    </div>
</template>

<script>
    import {formatTotal} from "../../utils";

    export default {
        name: "ActivityStack",
        
        props: {
            'project': {
                type: Object,
                required: true
            },
            invoiced: {
                type: Object | Array,
                required: false
            }
        },
        
        methods: {
            formatTotal(seconds) {
                return formatTotal(seconds);
            },

            markAsInvoiced(activity) {
                let data = Object.assign({}, activity);
                data.invoiced = !activity.invoiced;
                
                this.$store.dispatch("saveActivity", data)
                    .then(() => {
                        activity.invoiced = data.invoiced;
                    });
            },

            formatActivityDate(datetime) {
                return moment(datetime, "YYYY-MM-DD hh:mm:ss").format("DD.MM.YYYY hh:mm:ss");

            }
        }
    }
</script>

<style scoped>

</style>